import { motion } from "framer-motion";

// WhatsApp brand icon (lucide doesn't ship one)
function WhatsAppIcon({ size = 28 }) {
  return (
    <svg viewBox="0 0 32 32" width={size} height={size} fill="currentColor" aria-hidden="true">
      <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39-.93-.395-1.834-.886-2.671-1.471-.764-.696-1.41-1.512-1.916-2.417-.354-.692.529-1.392.736-1.692.347-.317.494-.79.385-1.236-.27-.643-1.05-2.69-1.477-3.602-.354-.731-.99-.55-1.49-.55-1.31 0-2.198 1.378-2.198 2.642-.057 1.602.508 3.165 1.575 4.36 1.998 2.892 4.625 5.276 7.683 6.97 1.41.673 2.022.736 3.013.567.792-.146 2.305-.94 2.616-1.873.32-.96.32-1.766.231-1.95-.122-.18-.323-.296-.539-.314-.222-.111-1.685-.788-1.94-.886"></path>
      <path d="M16.063 28.825h-.04c-2.224-.001-4.41-.557-6.359-1.622L1 30l2.812-8.392a13.106 13.106 0 01-1.749-6.55C2.069 7.785 8.34 1.624 16.061 1.624c3.747 0 7.27 1.444 9.918 4.067a13.748 13.748 0 014.103 9.78c-.003 7.43-6.07 13.354-13.92 13.354zm0-24.97c-6.421 0-11.642 5.124-11.645 11.42 0 2.158.621 4.25 1.797 6.054l.279.434-1.665 4.97 5.142-1.342.42.247a11.728 11.728 0 005.93 1.598h.004c5.964 0 11.547-4.926 11.55-11.224a10.797 10.797 0 00-3.388-7.812 11.504 11.504 0 00-8.16-3.339"></path>
    </svg>
  );
}

export default function WhatsAppBubble({ href = "#" }) {
  const handleClick = (e) => {
    if (href === "#" || !href) {
      e.preventDefault();
      // Friendly placeholder behavior until the user supplies a real WhatsApp link
      console.info("WhatsApp link is not configured yet.");
    }
  };

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat us on WhatsApp"
      data-testid="whatsapp-bubble"
      onClick={handleClick}
      initial={{ opacity: 0, scale: 0.6, y: 30 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.2, type: "spring", stiffness: 260, damping: 22 }}
      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.96 }}
      className="fixed bottom-6 right-6 z-50 group"
    >
      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-50 animate-ping" />

      <span className="relative flex items-center gap-3 bg-[#25D366] text-white pl-4 pr-5 py-3 rounded-full shadow-[0_10px_30px_-5px_rgba(37,211,102,0.6)] hover:shadow-[0_15px_40px_-5px_rgba(37,211,102,0.8)] transition-shadow">
        <WhatsAppIcon size={22} />
        <span className="text-sm font-semibold tracking-wide hidden sm:inline">Chat us</span>
      </span>
    </motion.a>
  );
}
